import React, { useEffect, useState } from "react";
import SearchImg from "../../../assets/user/images/search1.svg";
import UserImg from "../../../assets/user/images/user.png";
import TrashImg from "../../../assets/user/images/trash.svg";
import Edit2 from "../../../assets/user/images/edit-2.svg";
import Reply from "../../../assets/user/images/reply.svg";
import Like from "../../../assets/user/images/like.svg";
import EditIcon from "../../../assets/user/images/editicon.svg";
import TrashIcon from "../../../assets/user/images/trash1.svg";
import DatePicker from "react-datepicker";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../layouts/loader/Loader";
import { api } from "../../../utlis/staff/api.utlis";
import toast from "react-hot-toast";
import ApiService from "../../../core/services/ApiService";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import moment from "moment";
import uploadImage from "../../../assets/admin/images/uploadImage.svg";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { SingleFile } from "../../../utlis/common.utlis";
import { Formik, Field, Form, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import { routes } from "../../../utlis/staff/routes.utlis";
import { decode } from "base-64";

const PostDetails = () => {
  const navigate = useNavigate();
  const localData = useLocation();
  const id = localData.state?.id;
  const communityCreated = localData.state?.isCreated;
  const [details, setDetails] = useState();
  const [loading, setLoading] = useState(false);
  const [creation, setCreate] = useState({
    status: false,
    post_id: null,
    parent_id: null,
  });
  const [desc, setDesc] = useState({
    status: false,
    description: null,
  });
  const [editComment, setEditComment] = useState({
    status: false,
    id: null,
    comment: null,
  });
  const [deletePost, setDeletePost] = useState({
    status: false,
    id: null,
  });
  const [deleteComment, setDeleteComment] = useState({
    status: false,
    id: null,
  });
  const [editPost, setEditPost] = useState({
    status: false,
    id: null,
    title: null,
    description: null,
    post_image: null,
  });

  const initialValues = {
    comment: "",
  };

  const initialEditCommentValues = {
    comment: editComment?.comment ?? "",
  };

  const initialEditValues = {
    poll_title: editPost.title ?? "",
    description: editPost.description ?? "",
    post_image: "",
  };

  const validationSchema = Yup.object().shape({
    comment: Yup.string().required("Comment is required!"),
  });

  const validationEditSchema = Yup.object().shape({
    poll_title: Yup.string().required("Title is required!"),
    description: Yup.string().required("Description is required!"),
    post_image: Yup.mixed()
      .test(
        "fileSize",
        "File size is too large",
        (value) => !value || (value && value.size <= SingleFile * 1024 * 1024)
      )
      .test("fileType", "Unsupported file type", (value) => {
        return value != "" && value != null && value != undefined
          ? ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
          : true;
      }),
  });

  const updatePost = async (formValue) => {
    setLoading(true);
    let form = new FormData();
    form.append("poll_title", formValue.poll_title);
    form.append("description", formValue.description);
    if (formValue.post_image) {
      form.append("post_image", formValue.post_image);
    }
    const response = await ApiService.putAPIWithAccessTokenMultiPart(
      api.postUpdate + `${decode(id)}`,
      form
    );
    setEditPost({
      status: false,
      id: null,
      title: null,
      description: null,
      post_image: null,
    });
    document.getElementById("update-post-form").reset();
    if (response.data.status) {
      toast.success(response.data.message);
      getDetails(api.communityPostDetail + `${decode(id)}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const addComment = async (formValue) => {
    setLoading(true);
    let form = JSON.stringify({
      post_id: creation.post_id,
      parent_id: creation.parent_id ?? null,
      comment: formValue.comment,
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.postComment,
      form
    );
    setCreate({ status: false, post_id: null, parent_id: null });
    document.getElementById("add-comment-form").reset();
    if (response.data.status) {
      toast.success(response.data.message);
      getDetails(api.communityPostDetail + `${decode(id)}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const updateComment = async (formValue) => {
    setLoading(true);
    let form = JSON.stringify({
      comment: formValue.comment,
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.commentUpdate + `${editComment.id}`,
      form
    );
    setEditComment({ status: false, id: null, comment: null });
    document.getElementById("update-comment-form").reset();
    if (response.data.status) {
      toast.success(response.data.message);
      getDetails(api.communityPostDetail + `${decode(id)}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const deleteMyPost = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.communityPostDelete + `${deletePost.id}`
    );
    setDeletePost({ status: false, id: null });
    if (response.data.status) {
      toast.success(response.data.message);
      navigate(-1);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const deleteMyComment = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.communityCommentDelete + `${deleteComment.id}`
    );
    setDeleteComment({ status: false, id: null });
    if (response.data.status) {
      toast.success(response.data.message);
      getDetails(api.communityPostDetail + `${decode(id)}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const getDetails = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("community details => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setDetails(response.data.data.postDetail);
    } else {
      setDetails();
    }
    setLoading(false);
  };

  const likeUnlike = async (postId, ans) => {
    setLoading(true);
    const form = JSON.stringify({
      post_id: postId,
      object_type: "post",
      reaction: ans,
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.postReaction,
      form
    );
    if (response.data.status) {
      // toast.success(response.data.message);
      getDetails(api.communityPostDetail + `${decode(id)}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const likeUnlikeComment = async (commentId, ans) => {
    setLoading(true);
    const form = JSON.stringify({
      comment_id: commentId,
      object_type: "comment",
      reaction: ans,
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.commentReaction,
      form
    );
    if (response.data.status) {
      toast.success(response.data.message);
      getDetails(api.communityPostDetail + `${decode(id)}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const pollAnswer = async (pollId, ansId) => {
    setLoading(true);
    const form = JSON.stringify({
      poll_id: pollId,
      answer_id: ansId,
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.pollAnswer,
      form
    );
    if (response.data.status) {
      toast.success(response.data.message);
      getDetails(api.communityPostDetail + `${decode(id)}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getDetails(api.communityPostDetail + `${decode(id)}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="community--details-info">
          <div className="community-title-header">
            <h2 className="heading-title">Post Detail</h2>
            <div className="search-filter wd10">
              <div className="row g-2">
                <div className="col-md-12">
                  <Link
                    className="btn-gr wd100"
                    to=""
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="community-details-media">
                <div className="community-details-image-item">
                  {details?.post_image === null ||
                  details?.post_image === "" ||
                  details?.post_image === undefined ? (
                    <img src={NoImage} alt="" />
                  ) : (
                    <img src={details?.post_image} alt="" />
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-7">
              <div className="community-details-desc">
                <div className="community-details-head">
                  <div className="community-details-text">
                    <h4 className="text-capitalize">
                      {details?.poll_title ?? "NA"}
                    </h4>
                  </div>
                </div>

                <div className="community-head-1">
                  <div className="community-head-media-1">
                    {details?.profile_image === null ||
                    details?.profile_image === "" ||
                    details?.profile_image === undefined ? (
                      <img src={NoImage} alt="" />
                    ) : (
                      <img src={details?.profile_image} alt="" />
                    )}
                  </div>
                  <div className="community-head-content-1">
                    <h4 className="text-capitalize">
                      {details?.fullname ?? "NA"}
                    </h4>
                  </div>
                  <div className="community-head-action-1 d-flex align-items-center">
                    <div className="mt-1">
                      {details?.post_type !== "normal_post" && (
                        <div className="exp-text mx-2 mb-1">Shared Post</div>
                      )}
                    </div>
                    <div
                      className="like-button-comm"
                      onClick={(e) => {
                        e.preventDefault();
                        likeUnlike(
                          details?.post_id,
                          details?.isLiked == "true" ? "unlike" : "like"
                        );
                      }}
                    >
                      <input
                        className="on"
                        id="heart"
                        type="checkbox"
                        checked={details?.isLiked == "true" ? true : false}
                      />
                      <label className="like-comm" for="heart">
                        <svg
                          className="like-icon-comm"
                          fill-rule="nonzero"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"></path>
                        </svg>
                        <span className="like-text-comm">Like</span>
                      </label>
                      <span className="like-count-comm">
                        {details?.like_count ?? 0}
                      </span>
                    </div>
                  </div>
                </div>
                <p>
                  {details?.description ? (
                    details.description.length >= 75 ? (
                      <>
                        {details.description.slice(0, 75)}.....{" "}
                        <Link
                          style={{ color: "blue", textDecoration: "underline" }}
                          to=""
                          onClick={(e) => {
                            e.preventDefault();
                            setDesc({
                              status: true,
                              description: details?.description,
                            });
                          }}
                        >
                          read more
                        </Link>
                      </>
                    ) : (
                      details.description
                    )
                  ) : (
                    "NA"
                  )}
                </p>
                {(details?.isCreated == "true" ||
                  communityCreated == "true") && (
                  <div className="community-details-action-1">
                    <button
                      className="btn-gr"
                      onClick={() =>
                        setEditPost({
                          status: true,
                          id: details?.id,
                          title: details?.poll_title,
                          description: details?.description,
                          post_image: details?.post_image,
                        })
                      }
                    >
                      <img src={Edit2} /> Edit
                    </button>
                    <button
                      className="btn-re mx-2"
                      onClick={() =>
                        setDeletePost({ status: true, id: details?.post_id })
                      }
                    >
                      <img src={TrashImg} /> Delete
                    </button>
                  </div>
                )}
              </div>

              {details?.poll_options?.length !== 0 ? (
                <div className="community-details-member-section">
                  <div className="row align-items-center g-2">
                    <div className="col-md-12">
                      <div className="community-memberlist d-flex flex-column">
                        <div className="community-memberlist-text text-start w-100 mb-3">
                          <h2>
                            Poll ({details?.total_vote_count ?? 0} Person
                            Answered)
                          </h2>
                        </div>
                        <div className="w-100">
                          {details?.poll_options?.map((element, index) => {
                            return (
                              <div key={index} className="poll-option selected">
                                <div className="poll-header">
                                  <label>
                                    <input
                                      type="radio"
                                      name="poll"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        pollAnswer(
                                          details?.poll_id,
                                          element.option_id
                                        );
                                      }}
                                      checked={
                                        element.isAnswer == "true"
                                          ? true
                                          : false
                                      }
                                    />
                                    {element.option_value}
                                  </label>
                                  <span>{element.vote_percentage}</span>
                                </div>
                                <div className="poll-bar">
                                  <div
                                    className="poll-fill"
                                    style={{
                                      width: `${element.vote_percentage}`,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="col-md-12 mt-3">
          <div className="community-comment-section">
            <div className="community-comment-list">
              <div className="community-comment-box-head">
                <h1>Post Comments</h1>
                <div className="community-comment-head-action">
                  <Link
                    className="addcomment-btn"
                    to=""
                    onClick={(e) => {
                      e.preventDefault();
                      setCreate({
                        status: true,
                        post_id: decode(id),
                        parent_id: null,
                      });
                    }}
                  >
                    <i className="fa fa-plus"></i> Add comment
                  </Link>
                </div>
              </div>

              {details?.top_comments?.length !== 0 ? (
                details?.top_comments?.map((ele, indx) => {
                  return (
                    <>
                      <div key={indx} className="community-comment-item">
                        <div className="community-comment-profile">
                          {ele.profile_image === null ||
                          ele.profile_image === "" ||
                          ele.profile_image === undefined ? (
                            <img src={NoImage} alt="" />
                          ) : (
                            <img src={ele.profile_image} alt="" />
                          )}
                        </div>
                        <div className="community-comment-content">
                          <div className="community-comment-head">
                            <h2 className="text-capitalize">
                              {ele.fullname ?? "NA"}
                            </h2>
                            <div className="community-date">
                              <i className="las la-calendar"></i>
                              {moment(ele.created_date).format(
                                "MM-DD-yyyy H:m"
                              )}
                            </div>
                          </div>
                          <div className="community-comment-descr">
                            {ele.comment ?? "NA"}
                          </div>
                          <div className="community-comment-action">
                            <Link
                              className="Reply-btn"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                setCreate({
                                  status: true,
                                  post_id: decode(id),
                                  parent_id: ele?.comment_id,
                                });
                              }}
                            >
                              <img src={Reply} /> Reply
                            </Link>
                            {ele?.is_liked_by_user == "true" ? (
                              <Link
                                className="likebtn mx-1"
                                to=""
                                onClick={(e) => {
                                  e.preventDefault();
                                  likeUnlikeComment(ele?.comment_id, "unlike");
                                }}
                              >
                                <svg
                                  width="18"
                                  height="19"
                                  viewBox="0 0 18 19"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="#132A3A"
                                >
                                  <path
                                    d="M5.60999 14.3324L7.93498 16.1324C8.23498 16.4324 8.90998 16.5824 9.35998 16.5824H12.21C13.11 16.5824 14.085 15.9074 14.31 15.0074L16.11 9.53242C16.485 8.48242 15.81 7.58242 14.685 7.58242H11.685C11.235 7.58242 10.86 7.20742 10.935 6.68242L11.31 4.28242C11.46 3.60742 11.01 2.85742 10.335 2.63242C9.73498 2.40742 8.98498 2.70742 8.68498 3.15742L5.60999 7.73242"
                                    stroke="#132A3A"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                  />
                                  <path
                                    d="M1.78503 14.3324V6.98237C1.78503 5.93237 2.23503 5.55737 3.28503 5.55737H4.03503C5.08503 5.55737 5.53503 5.93237 5.53503 6.98237V14.3324C5.53503 15.3824 5.08503 15.7574 4.03503 15.7574H3.28503C2.23503 15.7574 1.78503 15.3824 1.78503 14.3324Z"
                                    stroke="#132A3A"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                {ele?.like_count ?? 0} Like
                              </Link>
                            ) : (
                              <Link
                                className="likebtn mx-1"
                                to=""
                                onClick={(e) => {
                                  e.preventDefault();
                                  likeUnlikeComment(ele?.comment_id, "like");
                                }}
                              >
                                <img src={Like} /> {ele?.like_count ?? 0} Like
                              </Link>
                            )}
                            {(ele?.is_commented_by_user == true ||
                              details?.isCreated == "true") && (
                              <>
                                <Link
                                  to=""
                                  className="Editbtn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setEditComment({
                                      status: true,
                                      id: ele?.comment_id,
                                      comment: ele?.comment,
                                    });
                                  }}
                                >
                                  <img src={EditIcon} /> Edit
                                </Link>
                                <Link
                                  to=""
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setDeleteComment({
                                      status: true,
                                      id: ele?.comment_id,
                                    });
                                  }}
                                  className="delete-btn1 mx-1"
                                >
                                  <img src={TrashIcon} /> Delete
                                </Link>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                      {ele?.reply?.length !== 0
                        ? ele?.reply?.map((element, index) => {
                            return (
                              <div
                                key={index}
                                className="community-comment-item  sub-comment"
                              >
                                <div className="community-comment-profile">
                                  {element.profile_image === null ||
                                  element.profile_image === "" ||
                                  element.profile_image === undefined ? (
                                    <img src={NoImage} alt="" />
                                  ) : (
                                    <img src={element.profile_image} alt="" />
                                  )}
                                </div>
                                <div className="community-comment-content">
                                  <div className="community-comment-head">
                                    <h2 className="text-capitalize">
                                      {element.fullname ?? "NA"}
                                    </h2>
                                    <div className="community-date">
                                      <i className="las la-calendar"></i>
                                      {moment(element.created_date).format(
                                        "MM-DD-yyyy H:m"
                                      )}
                                    </div>
                                  </div>
                                  <div className="community-comment-descr">
                                    {element.comment ?? "NA"}
                                  </div>
                                  <div className="community-comment-action">
                                    <Link
                                      className="Reply-btn"
                                      to=""
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setCreate({
                                          status: true,
                                          post_id: decode(id),
                                          parent_id: ele?.comment_id,
                                        });
                                      }}
                                    >
                                      <img src={Reply} /> Reply
                                    </Link>
                                    {element?.is_liked_by_user == "true" ? (
                                      <Link
                                        className="likebtn mx-1"
                                        to=""
                                        onClick={(e) => {
                                          e.preventDefault();
                                          likeUnlikeComment(
                                            element?.comment_id,
                                            "unlike"
                                          );
                                        }}
                                      >
                                        <svg
                                          width="18"
                                          height="19"
                                          viewBox="0 0 18 19"
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="#132A3A"
                                        >
                                          <path
                                            d="M5.60999 14.3324L7.93498 16.1324C8.23498 16.4324 8.90998 16.5824 9.35998 16.5824H12.21C13.11 16.5824 14.085 15.9074 14.31 15.0074L16.11 9.53242C16.485 8.48242 15.81 7.58242 14.685 7.58242H11.685C11.235 7.58242 10.86 7.20742 10.935 6.68242L11.31 4.28242C11.46 3.60742 11.01 2.85742 10.335 2.63242C9.73498 2.40742 8.98498 2.70742 8.68498 3.15742L5.60999 7.73242"
                                            stroke="#132A3A"
                                            stroke-width="1.5"
                                            stroke-miterlimit="10"
                                          />
                                          <path
                                            d="M1.78503 14.3324V6.98237C1.78503 5.93237 2.23503 5.55737 3.28503 5.55737H4.03503C5.08503 5.55737 5.53503 5.93237 5.53503 6.98237V14.3324C5.53503 15.3824 5.08503 15.7574 4.03503 15.7574H3.28503C2.23503 15.7574 1.78503 15.3824 1.78503 14.3324Z"
                                            stroke="#132A3A"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </svg>
                                        {element?.like_count ?? 0} Like
                                      </Link>
                                    ) : (
                                      <Link
                                        className="likebtn mx-1"
                                        to=""
                                        onClick={(e) => {
                                          e.preventDefault();
                                          likeUnlikeComment(
                                            element?.comment_id,
                                            "like"
                                          );
                                        }}
                                      >
                                        <img src={Like} />{" "}
                                        {element?.like_count ?? 0} Like
                                      </Link>
                                    )}
                                    {element?.is_commented_by_user == true && (
                                      <>
                                        <Link
                                          to=""
                                          className="Editbtn"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setEditComment({
                                              status: true,
                                              id: element?.comment_id,
                                              comment: element?.comment,
                                            });
                                          }}
                                        >
                                          <img src={EditIcon} /> Edit
                                        </Link>
                                        <Link
                                          to=""
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setDeleteComment({
                                              status: true,
                                              id: element?.comment_id,
                                            });
                                          }}
                                          className="delete-btn1 mx-1"
                                        >
                                          <img src={TrashIcon} /> Delete
                                        </Link>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        : null}
                    </>
                  );
                })
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "5% 0",
                  }}
                >
                  <img width={300} src={NoData} alt="" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={deletePost.status}
        onHide={() => {
          setDeletePost({ status: false, id: null });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Community Post</h5>
                <p className="text-center">
                  Deleting this community post cannot be undone. Are you sure
                  you want to proceed ?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() => setDeletePost({ status: false, id: null })}
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => deleteMyPost()}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={deleteComment.status}
        onHide={() => {
          setDeleteComment({ status: false, id: null });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Post Comment</h5>
                <p className="text-center">
                  Deleting this post comment cannot be undone. Are you sure you
                  want to proceed ?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() => setDeleteComment({ status: false, id: null })}
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => deleteMyComment()}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={creation.status}
        onHide={() => {
          setCreate({
            status: false,
            post_id: null,
            parent_id: null,
          });
        }}
        className=""
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">
              {creation.parent_id == null ? "Add" : "Reply"} Comment
            </h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={addComment}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form" id="add-comment-form">
                    <div className="form-group">
                      <h4>Comment</h4>
                      <Field
                        type="text"
                        as="textarea"
                        className="form-control"
                        name="comment"
                        placeholder="Enter Your Comment"
                        style={{ height: "150px" }}
                      />
                      <ErrorMessage
                        name="comment"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group text-end">
                      <button
                        type="button"
                        onClick={() => {
                          setCreate({
                            status: false,
                            post_id: null,
                            parent_id: null,
                          });
                        }}
                        className="btn btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-gr me-2"
                        data-bs-dismiss="modal"
                      >
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={desc.status}
        onHide={() => {
          setDesc({ status: false, description: null });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-text mb-0">
                <p className="p-3" style={{ color: "black" }}>
                  {desc.description ?? "NA"}
                </p>
              </div>
              <div className="form-group text-end mb-2">
                <button
                  type="button"
                  onClick={() => setDesc({ status: false, description: null })}
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={editComment.status}
        onHide={() => {
          setEditComment({
            status: false,
            id: null,
            comment: null,
          });
        }}
        className=""
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Comment</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialEditCommentValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={updateComment}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form" id="update-comment-form">
                    <div className="form-group">
                      <h4>Comment</h4>
                      <Field
                        type="text"
                        as="textarea"
                        className="form-control"
                        name="comment"
                        placeholder="Enter Your Comment"
                        style={{ height: "150px" }}
                      />
                      <ErrorMessage
                        name="comment"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group text-end">
                      <button
                        type="button"
                        onClick={() => {
                          setEditComment({
                            status: false,
                            id: null,
                            comment: null,
                          });
                        }}
                        className="btn btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-gr me-2"
                        data-bs-dismiss="modal"
                      >
                        Update
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={editPost.status}
        onHide={() => {
          setEditPost({
            status: false,
            id: null,
            title: null,
            description: null,
            post_image: null,
          });
        }}
        className="modal-xl"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Post</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialEditValues}
                validateOnChange={true}
                validationSchema={validationEditSchema}
                onSubmit={updatePost}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form" id="update-post-form">
                    <div className="form-group">
                      <h4>Title</h4>
                      <Field
                        type="text"
                        className="form-control todo-list-input"
                        name="poll_title"
                        placeholder="Enter Title"
                      />
                      <ErrorMessage
                        name="poll_title"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group">
                      <h4>
                        Upload Image{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.7rem" }}
                        >
                          (In JPG, JPEG & PNG)
                        </span>
                      </h4>
                      <div className="upload-signature">
                        <Field name="post_image">
                          {({ field, form }) => (
                            <>
                              <input
                                type="file"
                                id="files"
                                accept="image/jpg, image/jpeg, image/png"
                                className="form-control addsignature todo-list-input"
                                style={{ position: "absolute" }}
                                onChange={(event) =>
                                  setFieldValue(
                                    "post_image",
                                    event.currentTarget.files[0]
                                  )
                                }
                              />
                              <label for="files">
                                <div className="signature-text">
                                  <span>
                                    <img src={uploadImage} alt="" />
                                    <small className="prev-filename">
                                      {values?.post_image?.name
                                        ? values?.post_image?.name
                                        : editPost.post_image ??
                                          "Click here to Upload Image"}
                                    </small>
                                  </span>
                                </div>
                              </label>
                            </>
                          )}
                        </Field>
                        <ErrorMessage
                          name="post_image"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <h4>Description</h4>
                      <Field
                        type="text"
                        as="textarea"
                        className="form-control"
                        name="description"
                        placeholder="Enter Description"
                        style={{ height: "150px" }}
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group text-end">
                      <button
                        type="button"
                        onClick={() => {
                          setEditPost({
                            status: false,
                            id: null,
                            title: null,
                            description: null,
                            post_image: null,
                          });
                        }}
                        className="btn btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-gr me-2"
                        data-bs-dismiss="modal"
                      >
                        Update
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default PostDetails;
